// extracted by mini-css-extract-plugin
module.exports = {"formField":"Case3_formField__0r5Iy","rotation":"Case3_rotation__eD9yW"};